<template>
  <div class="wlx-site-testDetail-wrapper">
    <header class="u-school-manager-head clearfix">
      <span class="fl sp-test-detail-title">培训详情</span>
      <el-button
        class="back-to-test-btn"
        size="small"
        type="primary"
        icon="el-icon-back"
        @click="beforePage"
      ></el-button>
    </header>
    <!-- <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-input v-model="teaName" placeholder="请输入讲师姓名" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-form-item>
    </el-form>-->
    <div class="u-table-main">
      <el-table
        ref="multipleeeeTable"
        :data="list"
        style="width: 100%;"
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="id" type="selection" width="55"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column prop="CreateDisplayName" label="学员姓名"></el-table-column>
        <el-table-column prop="DateCreated" label="报名时间"></el-table-column>
        <el-table-column label="考证情况">
          <template slot-scope="scope">
            <span v-if="scope.row.IsAdopt==0">正在审核</span>
            <span v-if="scope.row.IsAdopt==1">成功</span>
            <span v-if="scope.row.IsAdopt==2">失败</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="u-page-con">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="pageIndex"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1
    };
  },
  props: {
    attestationId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.getEnrollList(1);
  },
  methods: {
    getEnrollList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/Enroll/getEnrollList", {
          attestationId: this.attestationId,
          page: page,
          pageSize: this.pageSize
        })
        .then(rst => {
          if (rst.code == 1) {
            that.list = rst.list;
            that.total = rst.pagination.totalCount;
            that.pageSize = rst.pagination.pageSize;
            that.pageIndex = rst.pagination.pageIndex;
          }
        });
    },
    onPageChangeHandler(page) {
      this.getEnrollList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getEnrollList(1);
    },
    handleSelectionChange(val) {
      this.lecturerId = [];
      val.forEach(element => {
        this.lecturerId.push(element.id);
      });
    },
    beforePage() {
      this.$router.push({
        name: "siteTrainManager"
      });
    }
  }
};
</script>

<style lang="scss">
.wlx-site-testDetail-wrapper {
  .sp-test-detail-title {
    margin: 16px 0 0 20px;
    font-size: 18px;
    color: #2d82ff;
  }
  .back-to-test-btn {
    margin: 13px 62px 0 0;
  }
}
</style>

